// extracted by mini-css-extract-plugin
export default {"container":"styles_container__US+vP","content":"styles_content__PAZj0","icon":"styles_icon__W8hHs","action":"styles_action__68Ccf"};